import { makeStyles } from '@policygenius/mortar';

export default makeStyles((theme) => ({
  mainContent: {
    background: theme.colors.white,
    minHeight: 'calc(100vh - 60px - 144px)', // fills the view minus header and footer
    padding: [theme.spacing('large'), 0, theme.spacing('medium')],
    [`@media (min-width: ${theme.breakpoints.medium}px)`]: {
      minHeight: 'calc(100vh - 60px - 113px)', // fills the view minus header and footer
      padding: [theme.spacing('xxlarge'), 0],
    },
    [`@media (min-width: ${theme.breakpoints.large}px)`]: {
      minHeight: 'calc(100vh - 60px - 136px)', // fills the view minus header and footer
    },
  },
}));
